export default {
  init() {
    function label_and_input(event) {
      let $input = $(event.target);
      let $label = $input.closest('.input-container').find('label');
      return {
        $label,
        $input,
      };
    }

    function move_label_down(event) {
      let relevent = label_and_input(event);
      remove_error(relevent.$input);
      relevent.$label.addClass('move-down');
    }

    function move_label_up(event) {
      let relevent = label_and_input(event);
      if (relevent.$input.val().trim() == '') {
        add_error(relevent.$input);
        relevent.$label.removeClass('move-down');
      }
    }

    function add_error($elm) {
      $elm.addClass('error');
    }

    function remove_error($elm) {
      $elm.removeClass('error');
    }

    const $inputs = $('input,textarea');
    const $select = $('.form-select');
    $inputs.on('focus', move_label_down);
    $inputs.on('blur', move_label_up);

    $select.on('change blur', () => {
      !$select.val() ? add_error($select) : remove_error($select);
    });

    const $form = $('form');
    $form.on('submit', function(e) {
      const $this = $(this);
      let error_found = false;
      $inputs.each(function(i, elm) {
        if (
          elm.type !== 'hidden' &&
          elm.type !== 'submit' &&
          elm.value.trim() === ''
        ) {
          add_error($(elm));
          error_found = true;
        }
      });

      if ($select.val() == null) {
        add_error($select);
        error_found = true;
      }

      if (error_found) {
        add_error($this);
        e.preventDefault();
        return false;
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js